import { Button, Col, Form, Input, Radio, Row } from "antd";
import "../dc.scss";
import "./dcCharge.scss";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import ReactInputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";
import { commaDigits, complexDigitToman, convertCurrencyToRial, convertPersian, regexFormater, validateInput } from "../../../../tools/tools";
import { useLocation, useNavigate } from "react-router-dom";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { useDispatch, useSelector } from "react-redux";
import { switchPlanID } from "../../../../tools/services";
import ShopPage, { ShopSummary, toman } from "../../../auxiliary/shop/ShopPage";
import { useTaxPercent } from "../../../auxiliary/shop/WalletPrefactor";
import { chargeMath, DC_STEPS } from "../prefactor/dcPrefactor";

const DCCharge = () => {
	const [t] = useTranslation("global");
	const [frmCharge] = Form.useForm();
	const { queryValidChargeByPlanId, isValidMSISDNToBuyCharge } = useDealer();
	const nav = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const user = useSelector((state) => state?.another?._currentUser);
	const tax = useTaxPercent();

	// purchase: subscriber chosen in 360 / corporate search (then the mobile field is hidden)
	const [dc, setDc] = useState({
		purchase: location?.state || null,
		isPriceActive: false,
		chargeList: [],
	});

	useEffect(() => {
		const loadServChargeList = async () => {
			if (dc?.chargeList.length === 0) {
				let response = await queryValidChargeByPlanId({ planid: switchPlanID().directCharge });
				if (response) {
					// 0 = "مبلغ دلخواه" (custom amount)
					response.push(0);
					setDc((dc) => ({ ...dc, chargeList: response }));
				}
			}
		};
		loadServChargeList();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleComma = (e) => {
		let v = e.target.value;
		if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
			v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
			e.target.value = v;
			return v;
		} else {
			return "";
		}
	};

	const handleSubmit = async () => {
		try {
			dispatch(clearFormData(["dcCharge"]));
			let valid = await frmCharge.validateFields();
			if (valid) {
				let payload = {
					msisdn: dc?.purchase?.inT_MSISDN || regexFormater(valid.msisdn).removeSpace(),
					planid: switchPlanID().directCharge,
				};
				let response = await isValidMSISDNToBuyCharge(payload);
				if (response) {
					nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Prefactor, {
						state: {
							...response,
							msisdn: payload.msisdn,
							chargeAmount: dc.isPriceActive ? convertCurrencyToRial(regexFormater(valid.desiredamount).removeComma()) : valid.amount,
							purchase: dc?.purchase || null,
						},
					});
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleChangeCharge = (e) => setDc((dc) => ({ ...dc, isPriceActive: e.target.value === 0 }));

	// live summary: same maths as the pre-invoice
	const msisdnValue = Form.useWatch("msisdn", frmCharge);
	const amountValue = Form.useWatch("amount", frmCharge);
	const desiredValue = Form.useWatch("desiredamount", frmCharge);
	const chosen = dc.isPriceActive ? convertCurrencyToRial(parseInt(String(desiredValue || "").split(",").join("")) || 0) : amountValue || 0;
	const { commission, walletDebit } = chargeMath(chosen, tax, user?.cccommission);
	const shownMsisdn = dc?.purchase?.inT_MSISDN || String(msisdnValue || "").split("_").join("").trim();

	return (
		<ShopPage title={t("directCharge.title")} prefix="dc" steps={DC_STEPS} step={0} purchase={dc.purchase}>
			<Form form={frmCharge} layout="vertical" className="charge-layout">
				<Row gutter={[24, 24]}>
					<Col xs={24} lg={15}>
						{!dc?.purchase && (
							<section className="shop-section">
								<h4>
									<span className="num">۱</span>شماره موبایل مشترک
								</h4>
								<Form.Item className="input-normal" name="msisdn" rules={[validateInput({ t: t, validate: true, type: "msisdnOrg" })]}>
									<div>
										<ReactInputMask
											onChange={(e) => {
												e.target.value = convertPersian(e.target.value);
											}}
											className="msisdn-mask"
											dir="ltr"
											inputMode="numeric"
											autoComplete="off"
											mask="0\9\9\99 99 99 99"
										/>
									</div>
								</Form.Item>
							</section>
						)}
						<section className="shop-section">
							<h4>
								<span className="num">{dc?.purchase ? "۱" : "۲"}</span>مبلغ شارژ
							</h4>
							<Form.Item className="input-normal" name="amount" rules={[validateInput({ t: t, validate: true })]}>
								<Radio.Group className="opt-charge" onChange={handleChangeCharge}>
									{dc?.chargeList.map((item, key) => (
										<Radio key={key} value={item}>
											{item === 0 ? (
												<>
													<b>دلخواه</b>
													<small>مبلغ دیگر</small>
												</>
											) : (
												<>
													<b dir="ltr">{complexDigitToman(item)}</b>
													<small>تومان</small>
												</>
											)}
										</Radio>
									))}
								</Radio.Group>
							</Form.Item>
							{dc?.isPriceActive && (
								<Form.Item
									className="input-normal desired-amount"
									label="مبلغ دلخواه"
									name="desiredamount"
									rules={[validateInput({ t: t, validate: true, type: "charge" })]}>
									<Input onInput={handleComma} onPaste={(e) => e.preventDefault()} maxLength="8" dir="ltr" addonAfter="تومان" autoComplete="off" />
								</Form.Item>
							)}
						</section>
					</Col>
					<Col xs={24} lg={9}>
						<ShopSummary
							msisdn={shownMsisdn}
							empty={chosen > 0 ? null : "مبلغ شارژ را انتخاب کنید"}
							rows={[
								["مبلغ شارژ", toman(chosen)],
								["سود شما از فروش", toman(commission)],
							]}
							total={["برداشت از کیف پول", toman(walletDebit)]}
							action={
								<Button className="sum-action" size="large" block onClick={handleSubmit}>
									ادامه و پیش فاکتور
								</Button>
							}
						/>
					</Col>
				</Row>
			</Form>
		</ShopPage>
	);
};

export default DCCharge;
